(() => {
  const ROOT_SELECTOR = '[data-sb-show-lead]';
  const SUCCESS_TEXT = /\b(thank you|thanks|submitted|saved|received)\b/i;
  const SUCCESS_SELECTOR = [
    '[role="status"]',
    '[role="alert"]',
    '[data-success]',
    '[data-testid*="success" i]',
    '[class*="success" i]',
  ].join(',');

  const clearVisitorFields = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('form').forEach((form) => form.reset());
    scope.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea').forEach((field) => {
      if (field instanceof HTMLSelectElement) {
        field.selectedIndex = 0;
      } else if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });
  };

  class SilverBulletShowLead {
    constructor(root) {
      if (root.dataset.sbShowLeadReady === 'true') return;

      this.root = root;
      this.nativeStage = root.querySelector('[data-sb-show-native-stage]');
      this.successActions = root.querySelector('[data-sb-show-success-actions]');
      this.resetButtons = [...root.querySelectorAll('[data-sb-show-reset]')];
      this.isSuccessful = false;

      const query = new URLSearchParams(window.location.search);
      const source = `${query.get('utm_medium') || ''} ${query.get('sb_source') || ''}`.toLowerCase();
      this.isKiosk = root.dataset.sbKioskMode === 'true' && !source.includes('qr');
      root.dataset.sbShowKiosk = this.isKiosk ? 'true' : 'false';

      this.resetButtons.forEach((button) => {
        button.addEventListener('click', () => this.reset());
      });

      if (this.nativeStage) {
        this.nativeStage.addEventListener('submit', () => {
          this.root.dataset.sbShowSubmitted = 'true';
          window.setTimeout(() => this.detectSuccess(), 500);
          window.setTimeout(() => this.detectSuccess(), 1600);
        }, true);
      }

      this.prepareFields();
      this.detectSuccess();
      const serverError = this.nativeStage?.querySelector('.sb-show-lead__form-errors');
      if (serverError) window.requestAnimationFrame(() => serverError.focus());
      root.dataset.sbShowLeadReady = 'true';
    }

    prepareFields() {
      if (!this.nativeStage || !this.isKiosk) return;

      this.nativeStage.querySelectorAll('input:not([type="hidden"]), textarea').forEach((field) => {
        const autocapitalize = field.type === 'email' ? 'none' : 'sentences';
        if (field.getAttribute('autocomplete') !== 'off') field.setAttribute('autocomplete', 'off');
        if (field.getAttribute('autocapitalize') !== autocapitalize) {
          field.setAttribute('autocapitalize', autocapitalize);
        }
      });
    }

    detectSuccess() {
      if (!this.nativeStage || this.isSuccessful) return;

      const successNode = [...this.nativeStage.querySelectorAll(SUCCESS_SELECTOR)].find((node) => {
        return !node.hidden && SUCCESS_TEXT.test((node.textContent || '').trim());
      });

      if (!successNode) return;

      this.isSuccessful = true;
      this.root.dataset.sbShowSuccess = 'true';
      if (this.isKiosk) {
        this.resetButtons.forEach((button) => {
          button.textContent = 'Start next visitor';
        });

        if (this.successActions) {
          this.successActions.hidden = false;
        }
      }
    }

    hasEnteredData() {
      if (!this.nativeStage) return false;

      return [...this.nativeStage.querySelectorAll('input:not([type="hidden"]), select, textarea')].some((field) => {
        if (field.type === 'checkbox' || field.type === 'radio') return field.checked;
        return String(field.value || '').trim() !== '';
      });
    }

    clearFields() {
      clearVisitorFields(this.nativeStage);
    }

    reset() {
      if (!this.isSuccessful && this.hasEnteredData()) {
        const shouldClear = window.confirm("Clear this visitor's entries and start over?");
        if (!shouldClear) return;
      }

      this.clearFields();
      window.location.replace(`${window.location.pathname}${window.location.search}`);
    }
  }

  const initialize = (scope = document) => {
    const roots = scope.matches?.(ROOT_SELECTOR) ? [scope] : scope.querySelectorAll(ROOT_SELECTOR);
    roots.forEach((root) => new SilverBulletShowLead(root));
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll(`${ROOT_SELECTOR}[data-sb-show-kiosk="true"]`).forEach((root) => clearVisitorFields(root));
  });
})();
